import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReduxUserGroupsSearchState } from '../types';
import { ReduxSliceState } from '../../../shared/types';
import { UserGroup, UserGroupTestPrice } from '../../../api/types';
import { ReduxRootState } from '../../../shared/redux/store';

const initialState: ReduxUserGroupsSearchState = {
    state: 'BUSY',
    userGroups: [],
};

export const loadUserGroups = createAction('userGroups/search/loadUserGroups');

const userGroupsSearchSlice = createSlice({
    name: 'userGroups/search',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setUserGroups: (state, action:PayloadAction<UserGroup[]>) => {
            state.userGroups = action.payload;
        },
    }
});

export default userGroupsSearchSlice;

const selectSelf = (state: ReduxRootState) => state.userGroupsSearch;
export const selectUserGroupsIsBusy = createSelector(selectSelf, self => self.state === 'BUSY');
export const selectUserGroupsSearchUserGroups = createSelector(selectSelf, self => self.userGroups);
